import { defineStore } from 'pinia';
import { pinia } from 'plugins/store/index';
import { computed, ref } from 'vue';

interface Nav extends Obj {
  isOpen: boolean;
  height: number;
  hidden: boolean;
}

const useStore = defineStore('nav', () => {
  const state = ref<Nav>({
    isOpen: false,
    height: 0,
    hidden: false,
  });

  //Actions
  // update nav state
  const openState = (value: boolean) => {
    state.value.isOpen = value;
  }

  // define the header height (for scrolling limits)
  const setHeight = (height: number) => {
    state.value.height = height;
  }

  const setHidden = (value: boolean) => {
    state.value.hidden = value;
  }

  return {
    state,

    //getters
    /**
     * get isOpen state
     */
    isOpen: computed(() => state.value.isOpen),

    /**
     * get height state
     */
    height: computed(() => state.value.height),
    hidden: computed(() => state.value.hidden),
    //actions
    openState,
    setHidden,
    setHeight,
  }
});

export const store = useStore(pinia);
export default store;
